import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpRequestService} from '../../../shared/services/http-request.service';
import {ImportModel} from '../../../models/typeform/import.model';

@Injectable()
export class TypeformService {

  private getInitDataUrl = environment.apiUrl + '/Typeform/GetInitData';
  private getWorkspaceInfoUrl = environment.apiUrl + '/Typeform/GetWorkspaceInfo';
  private importSurveyUrl = environment.apiUrl + '/Typeform/ImportSurvey';
  private importExistingSurveyUrl = environment.apiUrl + '/Typeform/ImportExistingSurvey';
  private typeFormAuthorizationUrl = environment.apiUrl + '/Typeform/IsTypeFormAuthorization';
  private getWorkspaceUrl = environment.apiUrl + '/Typeform/GetWorkspace';

  constructor(private http: HttpRequestService) {
  }

  getInitData() {
    return this.http.get(this.getInitDataUrl);
  }

  getWorkspace(clientId: Number) {
    return this.http.get(this.getWorkspaceUrl + '?clientId=' + clientId);
  }

  getWorkspaceInfo(idWorkSpace: string, clientId: Number) {
    return this.http.get(this.getWorkspaceInfoUrl + '?idWorkSpace=' + idWorkSpace + '&clientId=' + clientId);
  }

  isTypeFormAuthorization(clientId: Number) {
    return this.http.get(this.typeFormAuthorizationUrl + '?clientId=' + clientId);
  }

  importSurvey(survey: ImportModel) {
    return this.http.post(this.importSurveyUrl, survey);
  }

  ImportExistingSurvey(survey: ImportModel){    
    return this.http.post(this.importExistingSurveyUrl, survey);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/typeform/typeform.service.ts